import { render, staticRenderFns } from "./sock.vue?vue&type=template&id=0ee07172&"
import script from "./sock.vue?vue&type=script&lang=js&"
export * from "./sock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports